import { Buffer } from 'buffer';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

declare global {
  interface Window {
    global: Window;
    Buffer: typeof Buffer;
  }
}
export {};

// Polyfill: 'global' und 'Buffer' im Browser verfügbar machen
window.global ??= window;
window.Buffer ??= Buffer;

registerLocaleData(localeDe);
bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
